var map = {
  "./": "78110",
  "./activate": "40021",
  "./activate.js": "40021",
  "./disable": "56754",
  "./disable.js": "56754",
  "./edit": "14056",
  "./edit.js": "14056",
  "./index": "78110",
  "./index.js": "78110",
  "./new": "50708",
  "./new.js": "50708",
  "./show": "90669",
  "./show.js": "90669",
  "./types/base": "39459",
  "./types/base.js": "39459"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 96294;
